<div class="SLV2-main-wrapper">
    <div class="SLV2-playback-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <button (click)="navigateToPreviousPage()" class="SLV2-header-text-button">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                <span>Back</span>
            </button>
        </div>

        <div class="SLV2-playback-page-col-wrap">

            <div class="SLV2-playback-col left">
                <div class="SLV2-play-video-wrap">
                    <video  #video width="100%" autoplay controls controlsList="nodownload" (ended)="videoEnded()"
                    oncontextmenu="return false;" (timeupdate)="dispatchEventsOnTimeUpdate($event)" [src]="videoFullData?.videoURL" >
                    </video>
                </div>
                <div class="SLV2-play-video-content-wrap" #vdo_mob_dscrptn_expand>
                    <div class="SLV2-play-video-title-row">
                        <h2 class="SLV2-play-video-title">{{videoFullData?.title}}</h2>
                        <button class="SLV2-mob-expand-arrow-btn" (click)="vdo_mob_dscrptn_expand.classList.toggle('expand')"><img src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-icon.svg" /></button>
                    </div>
                    <div class="SLV2-play-subject-name physics">
                        <div class="SLV2-icn-box">
                            <img [src]="subjectIcon" />
                        </div>
                        <span>{{videoFullData?.nodes[0]?.nodeName}}</span>
                    </div>
                    <div class="SLV2-play-user-actn-row">
                        <button class="SLV2-user-btn like-btn">
                            <div class="SLV2-btn-icon" [ngClass]="{'active':this.isVideoLiked(this.videoFullData?.videoId)}" (click)="userLike()">
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/like-icon.svg" />
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/like-fill-icon.svg" class="color" />
                            </div>
                            <span>{{videoLikeCount == 0 ? ' ': videoLikeCount}}</span>
                        </button>
                        <button class="SLV2-user-btn dislike-btn">
                            <div class="SLV2-btn-icon" [ngClass]="{'active': this.isVideoDisLiked(this.videoFullData?.videoId)}" (click)="userDislike()">
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/dislike-icon.svg" />
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/dislike-fill-icon.svg" class="color" />
                            </div>
                            <span>Dislike</span>

                        </button>
                        <!-- <button class="SLV2-user-btn share-btn">
                            <div class="SLV2-btn-icon">
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/share-icon.svg" />
                            </div>
                            <span>Share</span>
                        </button> -->
                    </div>
                    <div *ngIf="videoFullData?.description?.length>1" class="SLV2-video-description" #vdo_dscrptn_expand>
                        <div class="SLV2-descrptn-hdr">
                            <span>Description</span>
                            <button class="SLV2-descrptn-arrow-btn" (click)="vdo_dscrptn_expand.classList.toggle('collaps')"><img src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-icon.svg" /></button>
                        </div>
                        <div class="SLV2-descrptn-content">
                            <p>{{videoFullData?.description}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="SLV2-playback-col right" >
                <h3 class="SLV2-playlist-heading" *ngIf="playlists.length>0"><span>Playlist</span></h3>

                <ul class="SLV2-playlist">
                    <li *ngFor="let playlist of playlists">
                        <app-playlist-card [playlistCardData]="playlist" (videoSelected)="onVideoSelected($event)"></app-playlist-card>
                    </li>
                </ul>
            </div>
            
        </div>

    </div>
</div>